// GOLDEN PATH CODE
// An example of mutations that update the local data that is displayed on the website
// Based on

// Hooks
import { useMutation } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { useFeatures, getEnabledFeatures } from '../../../hooks/features';
import { getClient } from '../../../utils/getClient';
import { OffboardAmbassadorRequest } from '@amzn/red-velvet-api';
// Types

const MUTATION_PREFIX = ['RedVelvetApi', 'ambassadors'];

export function useOffboardAmbassador() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useMutation({
    mutationKey: MUTATION_PREFIX.concat(['offboardAmbassador']),
    mutationFn: async (request: OffboardAmbassadorRequest) => {
      const result = await client.offboardAmbassador(request);

      return {
        result,
      };
    },
    onSuccess: (data) => {
      return data;
    },
  });
}
